<template>
    <div>
        <group-card title="Audit Logs" icon="history" padded>
          <template slot="actions">
            <md-checkbox v-model="showMailLog" :disabled="isEmailLogsDisabled">
              <md-tooltip md-direction="top" v-if="isEmailLogsDisabled">No Mail Audit Logs</md-tooltip>
                Show Mail Log
              </md-checkbox>
            <md-checkbox v-model="showAuctionLog" :disabled="isAuctionLogsDisabled">
              <md-tooltip md-direction="top" v-if="!isAuctionLogsDisabled">No Auction Audit Logs</md-tooltip>
                Show Auction Log
              </md-checkbox>
            <validated-select-input
              class="md-layout-item md-small-size-20 md-size-20"
              label="Filter"
              multiple
              v-model="selectedActions"
              :options="actions"
              :disabled="showMailLog || showAuctionLog"
            />
            <loading-icon-button
              class="md-primary"
              @click="getAuditLogs(true)"
              tooltip="Refresh"
              :loading="isLoading"
            >
              refresh
            </loading-icon-button>
          </template>
          <md-table v-model="filteredData" v-if="filteredData!=null && (!showMailLog && !showAuctionLog)" md-card md-fixed-header class="table-striped wide">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Comment Date & Time">{{ item.updated_at | datetime }}</md-table-cell>
              <md-table-cell md-label="Created By" md-sort-by="user">{{ item.user | name }}</md-table-cell>
              <md-table-cell md-label="Action Completed" md-sort-by="application">
                <div v-if="item.action=='view'">
                  Application Viewed
                </div>
                <div v-else-if="item.action=='emailSent'">
                  Email Sent
                </div>
                <div v-else-if="item.action=='sendToHubspot'">
                  Send to Hubspot
                </div>
                <div v-else-if="item.action=='requestDocuments'">
                  Documents Requested
                </div>
                <div v-else-if="item.action=='viewVeda'">
                  Veda Viewed
                </div>
                <div v-else-if="item.action=='update'">
                  <span class="neutral">Application Updated</span>
                </div>
                <div v-else-if="item.action=='updateStatus'">
                  <span class="neutral">Status Updated</span>
                </div>
                <div v-else-if="item.action=='transfer'">
                  <span class="neutral">Application Transfered</span>
                </div>
                <div v-else-if="item.action=='requestVeda'">
                  <span class="neutral">Credit File Requested</span>
                </div>
                <div v-else-if="item.action=='created'">
                  <span class="information">Application Created</span>
                </div>
                <div v-else>
                  <span class="actionText">{{ item.action }}</span>
                </div>
              </md-table-cell>
            </md-table-row>
          </md-table>

          <md-table v-model="mailAuditLogs" v-if="mailAuditLogs && showMailLog" md-card md-fixed-header>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Action Date & Time">{{ item.created_at | datetime }}</md-table-cell>
              <md-table-cell md-label="Created By">{{ item.created_by }}</md-table-cell>
              <md-table-cell md-label="Sent Email From">{{ item.from[0].address }}</md-table-cell>
              <md-table-cell md-label="Sent Email To">{{ item.to[0].address }}</md-table-cell>
              <md-table-cell md-label="Subject">{{ item.subject }}</md-table-cell>
              <md-table-cell md-label="Attachments">
                  <span v-for="(attachment, index) in item.attachments">
                    <a :href="attachment.path" target="_blank">Attachment {{ index+1 }} </a>
                  </span>
              </md-table-cell>
            </md-table-row>
          </md-table>

          <md-table v-model="auctionAuditLogs" v-if="auctionAuditLogs != null && showAuctionLog" md-card md-fixed-header class="table-striped wide">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Comment Date & Time">{{ item.updated_at | datetime }}</md-table-cell>
              <md-table-cell md-label="Created By" md-sort-by="user">{{ item.user | name }}</md-table-cell>
              <md-table-cell md-label="Action Completed">
                <div>
                  <span class="actionText">{{ item.action }}</span>
                </div>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </group-card>
    </div>
</template>
<script>
import {GroupCard} from "@/components";
import filters from "@/components/utils/filters";
import { mapGetters } from 'vuex';
import LoadingIconButton from "../components/LoadingIconButton";
import ValidatedSelectInput from "../components/ValidatedInput/ValidatedSelectInput";

export default {
  created() {
    this.getAuditLogs()
  },
  components: {
    ValidatedSelectInput,
    GroupCard,
    LoadingIconButton,
  },
  computed: {
    ...mapGetters([
      'application',
    ]),
    isAuctionLogsDisabled () {
      return !this.auctionAuditLogs || (this.auctionAuditLogs && !this.auctionAuditLogs.length)
    },
    isEmailLogsDisabled () {
      return !this.mailAuditLogs ||  (this.mailAuditLogs && !this.mailAuditLogs.length)
    }
  },
  watch: {
    application() {
      this.getAuditLogs();
    },
    selectedActions() {
      //filter auditlogs action data based on action array
      if (this.selectedActions && this.selectedActions.length > 0) {
        //based on selected actions, filter the audit logs data
        this.filteredData = this.auditLogs.audit.filter(item => {
          return this.selectedActions.includes(item.action);
        });
      } else {
        //if no actions are selected, show all audit logs
        if (this.auditLogs && this.auditLogs.audit && this.auditLogs.audit.length > 0) {
          this.filteredData = this.auditLogs.audit;
        }
      }
    },
  },
  data() {
    return {
      auditLogs: null,
      isLoading: false,
      actions: null,
      selectedActions: null,
      filteredData: null,
      mailAuditLogs: null,
      auctionAuditLogs: null,
      showAuctionLog: false,
      showMailLog: false,
      availableSections: [
        'Audit Logs',
        'Wallet Notification'
      ],
      currentSections: 'Audit Logs'
    }
  },
  methods: {
    async getAuditLogs(force=false) {
      this.isLoading = true;
      if (this.application) {
        try {
          this.selectedActions = null;
          this.auditLogs = await this.$store.dispatch('ensure_audit_logs', {id: this.application.loan.id, force: force});
          this.filteredData = this.auditLogs.audit;
          this.mailAuditLogs = this.auditLogs.mailAudit;
          this.auctionAuditLogs = this.auditLogs.auctionAudit ?? [];
        } catch (error) {
          console.error('Failed to get audit logs');
          console.error(error);
        }
      }
      this.getUniqueActions();
      this.isLoading = false;
    },
    getUniqueActions() {
      let actions = [];
      if (this.auditLogs) {
        this.auditLogs.audit.forEach(item => {
          if (actions.indexOf(item.action) == -1) {
            actions.push(item.action);
          }
        });
      }
      this.actions = actions;
    },
  },
  filters: {
    ...filters,
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/scss/theme.scss";

.md-progress-spinner {
    margin-left: 48%;
}

.good {
    filter: brightness(0.9);
    color: $color-good !important;
}

.neutral {
    filter: brightness(0.9);
    color: $color-neutral !important;
}

.bad {
    filter: brightness(0.9);
    color: $color-bad !important;
}

.information {
    filter: brightness(0.9);
    color: $color-information !important;
}

.actionText{
    text-transform: capitalize;
}
</style>
